@if (organisation) {
    <div class="summary">
        <div class="stat">
            <div class="stat-value">{{organisation.backup ? (organisation.backup.date | date:'d MMM yyyy') : 'None'}}</div>
            <div class="stat-label">Organisation backup</div>
        </div>
        <div class="stat">
            <div class="stat-value">{{modelBackupCount}}</div>
            <div class="stat-label">Model backups</div>
        </div>
    </div>
    @if (backupData.length) {
        <app-table [columns]="columns" [data]="backupData" (rowEvent)="handleRowEvent($event)"></app-table>
    }@else {
        <p class="empty">There are no backups yet. Back up a single model from the model toolbar, or the whole organisation with Create organisation backup.</p>
    }
}
